// Auto-generated by packages/db/scripts/generate-prisma-browser-enums.cjs
// Do not edit manually.

export const OrganizationPlan = {
  BASIC: "BASIC",
  BETTER: "BETTER",
  DEPRECATED: "DEPRECATED",
} as const
export type OrganizationPlan = (typeof OrganizationPlan)[keyof typeof OrganizationPlan]

export const UserRole = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ORG_ADMIN: "ORG_ADMIN",
  ORG_MEMBER: "ORG_MEMBER",
  ORG_GUEST: "ORG_GUEST",
} as const
export type UserRole = (typeof UserRole)[keyof typeof UserRole]

export const InformationRequestStatus = {
  OPENED: "OPENED",
  CLOSED: "CLOSED",
  CANCELED: "CANCELED",
} as const
export type InformationRequestStatus = (typeof InformationRequestStatus)[keyof typeof InformationRequestStatus]

export const CertificateRequestStatus = {
  OPENED: "OPENED",
  SUBMITTED: "SUBMITTED",
  REJECTED: "REJECTED",
  ACCEPTED: "ACCEPTED",
  CANCELED: "CANCELED",
} as const
export type CertificateRequestStatus = (typeof CertificateRequestStatus)[keyof typeof CertificateRequestStatus]

export const CertificateCategory = {
  TRANSACTION: "TRANSACTION",
  SCOPE: "SCOPE",
  OTHER_INITIATIVES: "OTHER_INITIATIVES",
  UNKNOWN: "UNKNOWN",
} as const
export type CertificateCategory = (typeof CertificateCategory)[keyof typeof CertificateCategory]

export const CertificateTrigger = {
  LINEN_COMPONENTS: "LINEN_COMPONENTS",
  VISCOSE_COMPONENTS: "VISCOSE_COMPONENTS",
  POLYESTER_PES_RECYCLED_COMPONENTS: "POLYESTER_PES_RECYCLED_COMPONENTS",
  COTTON_RECYCLED_COMPONENTS: "COTTON_RECYCLED_COMPONENTS",
  POLYAMID_PA_RECYCLED_COMPONENTS: "POLYAMID_PA_RECYCLED_COMPONENTS",
  ACRYLIC_RECYCLED_COMPONENTS: "ACRYLIC_RECYCLED_COMPONENTS",
  COTTON_ORGANIC_COMPONENTS: "COTTON_ORGANIC_COMPONENTS",
  WOOL_RECYCLED_COMPONENTS: "WOOL_RECYCLED_COMPONENTS",
  WOOL_MERINOS_COMPONENTS: "WOOL_MERINOS_COMPONENTS",
  WOOL_COMPONENTS: "WOOL_COMPONENTS",
  ALL_SUPPLIER: "ALL_SUPPLIER",
  ALL_COMPONENTS: "ALL_COMPONENTS",
  FOOTWEAR: "FOOTWEAR",
  LAST_SUPPLIER: "LAST_SUPPLIER",
  LEATHER_COMPONENTS: "LEATHER_COMPONENTS",
  LEATHER_MATERIALS: "LEATHER_MATERIALS",
  LAST_ACTIVITY: "LAST_ACTIVITY",
  ALL_MATERIALS: "ALL_MATERIALS",
  ALL_COMPONENTS_AND_MATERIALS: "ALL_COMPONENTS_AND_MATERIALS",
  ALL_OPERATIONS: "ALL_OPERATIONS",
  COTTON_REGENERATIVE_COMPONENTS: "COTTON_REGENERATIVE_COMPONENTS",
  COTTON_IN_CONVERSION_COMPONENTS: "COTTON_IN_CONVERSION_COMPONENTS",
  ORGANIC_HEMP_COMPONENTS: "ORGANIC_HEMP_COMPONENTS",
  SUSTAINABLE_HEMP_COMPONENTS: "SUSTAINABLE_HEMP_COMPONENTS",
  ORGANIC_JUTE_COMPONENTS: "ORGANIC_JUTE_COMPONENTS",
  SUSTAINABLE_LINEN_COMPONENTS: "SUSTAINABLE_LINEN_COMPONENTS",
  ORGANIC_LINEN_COMPONENTS: "ORGANIC_LINEN_COMPONENTS",
  SUSTAINABLE_LYOCELL_COMPONENTS: "SUSTAINABLE_LYOCELL_COMPONENTS",
  SUSTAINABLE_MODAL_COMPONENTS: "SUSTAINABLE_MODAL_COMPONENTS",
  SUSTAINABLE_MOHAIR_COMPONENTS: "SUSTAINABLE_MOHAIR_COMPONENTS",
  RECYCLED_POLYETHYLENE_COMPONENTS: "RECYCLED_POLYETHYLENE_COMPONENTS",
  POLYESTER_PES_PET_RECYCLED_COMPONENTS: "POLYESTER_PES_PET_RECYCLED_COMPONENTS",
  VISCOSE_VI_RECYCLED_COMPONENTS: "VISCOSE_VI_RECYCLED_COMPONENTS",
  WOOL_MERINOS_RECYCLED_COMPONENTS: "WOOL_MERINOS_RECYCLED_COMPONENTS",
  WOOL_MERINOS_REGENERATIVE_COMPONENTS: "WOOL_MERINOS_REGENERATIVE_COMPONENTS",
  WOOL_SUSTAINABLE_COMPONENTS: "WOOL_SUSTAINABLE_COMPONENTS",
  WOOL_REGENERATIVE_COMPONENTS: "WOOL_REGENERATIVE_COMPONENTS",
  RECYCLED_CASHMERE_COMPONENTS: "RECYCLED_CASHMERE_COMPONENTS",
  SUSTAINABLE_VISCOSE_COMPONENTS: "SUSTAINABLE_VISCOSE_COMPONENTS",
  SUSTAINABLE_LEATHER_COMPONENTS: "SUSTAINABLE_LEATHER_COMPONENTS",
  SUSTAINABLE_LEATHER_BOVINE_COMPONENTS: "SUSTAINABLE_LEATHER_BOVINE_COMPONENTS",
  SUSTAINABLE_LEATHER_SPLIT_COMPONENTS: "SUSTAINABLE_LEATHER_SPLIT_COMPONENTS",
  SUSTAINABLE_LEATHER_LAMB_COMPONENTS: "SUSTAINABLE_LEATHER_LAMB_COMPONENTS",
  SUSTAINABLE_LEATHER_COW_COMPONENTS: "SUSTAINABLE_LEATHER_COW_COMPONENTS",
  SUSTAINABLE_LEATHER_CALF_COMPONENTS: "SUSTAINABLE_LEATHER_CALF_COMPONENTS",
  SUSTAINABLE_LEATHER_BUFFALO_COMPONENTS: "SUSTAINABLE_LEATHER_BUFFALO_COMPONENTS",
  SUSTAINABLE_LEATHER_PORC_COMPONENTS: "SUSTAINABLE_LEATHER_PORC_COMPONENTS",
  SUSTAINABLE_LEATHER_SHEEP_COMPONENTS: "SUSTAINABLE_LEATHER_SHEEP_COMPONENTS",
  SUSTAINABLE_LEATHER_GOAT_COMPONENTS: "SUSTAINABLE_LEATHER_GOAT_COMPONENTS",
  ELASTANE_RECYCLED_COMPONENTS: "ELASTANE_RECYCLED_COMPONENTS",
  NEVER: "NEVER",
  WOOD_HARVESTING: "WOOD_HARVESTING",
} as const
export type CertificateTrigger = (typeof CertificateTrigger)[keyof typeof CertificateTrigger]

export const RDUEComplianceStatus = {
  INCOMPLETE: "INCOMPLETE",
  VERIFICATION_REQUIRED: "VERIFICATION_REQUIRED",
  READY: "READY",
  COMPLIANT: "COMPLIANT",
} as const
export type RDUEComplianceStatus = (typeof RDUEComplianceStatus)[keyof typeof RDUEComplianceStatus]

export const CertificateAttribute = {
  ENVIRONMENTAL: "ENVIRONMENTAL",
  SOCIAL: "SOCIAL",
  AUDIT: "AUDIT",
  QUALITY_TESTING: "QUALITY_TESTING",
  WOOD: "WOOD",
} as const
export type CertificateAttribute = (typeof CertificateAttribute)[keyof typeof CertificateAttribute]

export const LangageIso6391 = {
  FR: "FR",
  EN: "EN",
  ZH: "ZH",
  PT: "PT",
  IT: "IT",
  ES: "ES",
  TR: "TR",
  NL: "NL",
  DE: "DE",
  AR: "AR",
  KO: "KO",
  JA: "JA",
  BE: "BE",
  RO: "RO",
  LT: "LT",
} as const
export type LangageIso6391 = (typeof LangageIso6391)[keyof typeof LangageIso6391]

export const MaterialTypeCategory = {
  ANIMAL: "ANIMAL",
  NATURAL: "NATURAL",
  SYNTHETIC: "SYNTHETIC",
  ARTIFICIAL: "ARTIFICIAL",
} as const
export type MaterialTypeCategory = (typeof MaterialTypeCategory)[keyof typeof MaterialTypeCategory]

export const CountryIso3166 = {
  AC: "AC",
  AD: "AD",
  AE: "AE",
  AF: "AF",
  AG: "AG",
  AI: "AI",
  AL: "AL",
  AM: "AM",
  AO: "AO",
  AQ: "AQ",
  AR: "AR",
  AS: "AS",
  AT: "AT",
  AU: "AU",
  AW: "AW",
  AX: "AX",
  AZ: "AZ",
  BA: "BA",
  BB: "BB",
  BD: "BD",
  BE: "BE",
  BF: "BF",
  BG: "BG",
  BH: "BH",
  BI: "BI",
  BJ: "BJ",
  BL: "BL",
  BM: "BM",
  BN: "BN",
  BO: "BO",
  BQ: "BQ",
  BR: "BR",
  BS: "BS",
  BT: "BT",
  BV: "BV",
  BW: "BW",
  BY: "BY",
  BZ: "BZ",
  CA: "CA",
  CC: "CC",
  CD: "CD",
  CF: "CF",
  CG: "CG",
  CH: "CH",
  CI: "CI",
  CK: "CK",
  CL: "CL",
  CM: "CM",
  CN: "CN",
  CO: "CO",
  CP: "CP",
  CR: "CR",
  CU: "CU",
  CV: "CV",
  CW: "CW",
  CX: "CX",
  CY: "CY",
  CZ: "CZ",
  DE: "DE",
  DG: "DG",
  DJ: "DJ",
  DK: "DK",
  DM: "DM",
  DO: "DO",
  DZ: "DZ",
  EA: "EA",
  EC: "EC",
  EE: "EE",
  EG: "EG",
  EH: "EH",
  ER: "ER",
  ES: "ES",
  ET: "ET",
  EU: "EU",
  FI: "FI",
  FJ: "FJ",
  FK: "FK",
  FM: "FM",
  FO: "FO",
  FR: "FR",
  GA: "GA",
  GB: "GB",
  GD: "GD",
  GE: "GE",
  GF: "GF",
  GG: "GG",
  GH: "GH",
  GI: "GI",
  GL: "GL",
  GM: "GM",
  GN: "GN",
  GP: "GP",
  GQ: "GQ",
  GR: "GR",
  GS: "GS",
  GT: "GT",
  GU: "GU",
  GW: "GW",
  GY: "GY",
  HK: "HK",
  HM: "HM",
  HN: "HN",
  HR: "HR",
  HT: "HT",
  HU: "HU",
  IC: "IC",
  ID: "ID",
  IE: "IE",
  IL: "IL",
  IM: "IM",
  IN: "IN",
  IO: "IO",
  IQ: "IQ",
  IR: "IR",
  IS: "IS",
  IT: "IT",
  JE: "JE",
  JM: "JM",
  JO: "JO",
  JP: "JP",
  KE: "KE",
  KG: "KG",
  KH: "KH",
  KI: "KI",
  KM: "KM",
  KN: "KN",
  KP: "KP",
  KR: "KR",
  KW: "KW",
  KY: "KY",
  KZ: "KZ",
  LA: "LA",
  LB: "LB",
  LC: "LC",
  LI: "LI",
  LK: "LK",
  LR: "LR",
  LS: "LS",
  LT: "LT",
  LU: "LU",
  LV: "LV",
  LY: "LY",
  MA: "MA",
  MC: "MC",
  MD: "MD",
  ME: "ME",
  MF: "MF",
  MG: "MG",
  MH: "MH",
  MK: "MK",
  ML: "ML",
  MM: "MM",
  MN: "MN",
  MO: "MO",
  MP: "MP",
  MQ: "MQ",
  MR: "MR",
  MS: "MS",
  MT: "MT",
  MU: "MU",
  MV: "MV",
  MW: "MW",
  MX: "MX",
  MY: "MY",
  MZ: "MZ",
  NA: "NA",
  NC: "NC",
  NE: "NE",
  NF: "NF",
  NG: "NG",
  NI: "NI",
  NL: "NL",
  NO: "NO",
  NP: "NP",
  NR: "NR",
  NU: "NU",
  NZ: "NZ",
  OM: "OM",
  PA: "PA",
  PE: "PE",
  PF: "PF",
  PG: "PG",
  PH: "PH",
  PK: "PK",
  PL: "PL",
  PM: "PM",
  PN: "PN",
  PR: "PR",
  PS: "PS",
  PT: "PT",
  PW: "PW",
  PY: "PY",
  QA: "QA",
  RE: "RE",
  RO: "RO",
  RS: "RS",
  RU: "RU",
  RW: "RW",
  SA: "SA",
  SB: "SB",
  SC: "SC",
  SD: "SD",
  SE: "SE",
  SG: "SG",
  SH: "SH",
  SI: "SI",
  SJ: "SJ",
  SK: "SK",
  SL: "SL",
  SM: "SM",
  SN: "SN",
  SO: "SO",
  SR: "SR",
  SS: "SS",
  ST: "ST",
  SV: "SV",
  SX: "SX",
  SY: "SY",
  SZ: "SZ",
  TA: "TA",
  TC: "TC",
  TD: "TD",
  TF: "TF",
  TG: "TG",
  TH: "TH",
  TJ: "TJ",
  TK: "TK",
  TL: "TL",
  TM: "TM",
  TN: "TN",
  TO: "TO",
  TR: "TR",
  TT: "TT",
  TV: "TV",
  TW: "TW",
  TZ: "TZ",
  UA: "UA",
  UG: "UG",
  UM: "UM",
  UN: "UN",
  US: "US",
  UY: "UY",
  UZ: "UZ",
  VA: "VA",
  VC: "VC",
  VE: "VE",
  VG: "VG",
  VI: "VI",
  VN: "VN",
  VU: "VU",
  WF: "WF",
  WS: "WS",
  XK: "XK",
  YE: "YE",
  YT: "YT",
  ZA: "ZA",
  ZM: "ZM",
  ZW: "ZW",
} as const
export type CountryIso3166 = (typeof CountryIso3166)[keyof typeof CountryIso3166]

export const CountryEcobalyse = {
  REO: "REO",
  REE: "REE",
  RAS: "RAS",
  RAF: "RAF",
  RME: "RME",
  RLA: "RLA",
  RNA: "RNA",
  ROC: "ROC",
  MM: "MM",
  BD: "BD",
  CN: "CN",
  FR: "FR",
  IN: "IN",
  KH: "KH",
  MA: "MA",
  PK: "PK",
  TN: "TN",
  TR: "TR",
  VN: "VN",
} as const
export type CountryEcobalyse = (typeof CountryEcobalyse)[keyof typeof CountryEcobalyse]

export const BusinessType = {
  SMALL_BUSINESS: "SMALL_BUSINESS",
  LARGE_BUSINESS_WITH_REPAIR: "LARGE_BUSINESS_WITH_REPAIR",
  LARGE_BUSINESS_WITHOUT_REPAIR: "LARGE_BUSINESS_WITHOUT_REPAIR",
} as const
export type BusinessType = (typeof BusinessType)[keyof typeof BusinessType]

export const EcobalyseActivityType = {
  MAKING: "MAKING",
  SPINNING: "SPINNING",
  DYEING: "DYEING",
  FABRIC: "FABRIC",
} as const
export type EcobalyseActivityType = (typeof EcobalyseActivityType)[keyof typeof EcobalyseActivityType]

export const EcobalyseFieldKey = {
  SURFACE_MASS: "SURFACE_MASS",
  YARN_SIZE_VALUE: "YARN_SIZE_VALUE",
  YARN_SIZE_UNIT: "YARN_SIZE_UNIT",
  DYEING_MEDIUM: "DYEING_MEDIUM",
  FABRIC_PROCESS: "FABRIC_PROCESS",
  AIR_TRANSPORT_RATIO: "AIR_TRANSPORT_RATIO",
  PRINTING_PROCESS: "PRINTING_PROCESS",
  PRINTING_PERCENTAGE: "PRINTING_PERCENTAGE",
  DYEING_PROCESS_TYPE: "DYEING_PROCESS_TYPE",
  UPCYCLING: "UPCYCLING",
  FADING: "FADING",
} as const
export type EcobalyseFieldKey = (typeof EcobalyseFieldKey)[keyof typeof EcobalyseFieldKey]

export const ComponentType = {
  MAIN_FABRIC: "MAIN_FABRIC",
  LINING: "LINING",
} as const
export type ComponentType = (typeof ComponentType)[keyof typeof ComponentType]

export const ESGAttributeType = {
  RECYCLED_CONTENT: "RECYCLED_CONTENT",
  GLOBAL_RECYCLED_STANDARD_GRS: "GLOBAL_RECYCLED_STANDARD_GRS",
  RECYCLE_CLAIM_STANDARD_100: "RECYCLE_CLAIM_STANDARD_100",
  BETTER_COTTON_INITIATIVE_BCI: "BETTER_COTTON_INITIATIVE_BCI",
  ISO_14001: "ISO_14001",
  OEKO_TEX_MADE_IN_GREEN: "OEKO_TEX_MADE_IN_GREEN",
  OEKO_TEX_STANDARD_100: "OEKO_TEX_STANDARD_100",
  ORGANIC_CONTENT: "ORGANIC_CONTENT",
} as const
export type ESGAttributeType = (typeof ESGAttributeType)[keyof typeof ESGAttributeType]

export const SendInBlueEventType = {
  REQUEST: "REQUEST",
  CLICK: "CLICK",
  DEFERRED: "DEFERRED",
  DELIVERED: "DELIVERED",
  SOFT_BOUNCE: "SOFT_BOUNCE",
  HARD_BOUNCE: "HARD_BOUNCE",
  COMPLAINT: "COMPLAINT",
  UNIQUE_OPENED: "UNIQUE_OPENED",
  OPENED: "OPENED",
  BLOCKED: "BLOCKED",
  INVALID_EMAIL: "INVALID_EMAIL",
  UNSUBSCRIBED: "UNSUBSCRIBED",
  TFG_UNKNOWN: "TFG_UNKNOWN",
  PROXY_OPEN: "PROXY_OPEN",
  ERROR: "ERROR",
  UNIQUE_PROXY_OPEN: "UNIQUE_PROXY_OPEN",
} as const
export type SendInBlueEventType = (typeof SendInBlueEventType)[keyof typeof SendInBlueEventType]

export const CertificateStatus = {
  NOT_UPLOADED: "NOT_UPLOADED",
  PENDING: "PENDING",
  PROCESSED: "PROCESSED",
  REJECTED: "REJECTED",
} as const
export type CertificateStatus = (typeof CertificateStatus)[keyof typeof CertificateStatus]

export const IngestionStatus = {
  PRODUCTS_PRE_VERIFIED: "PRODUCTS_PRE_VERIFIED",
  PENDING: "PENDING",
  BLANK_PRODUCTS_VERIFIED: "BLANK_PRODUCTS_VERIFIED",
  BLANK_PRODUCTS_INGESTED: "BLANK_PRODUCTS_INGESTED",
  PRODUCTS_VERIFIED: "PRODUCTS_VERIFIED",
  PRODUCTS_INGESTED: "PRODUCTS_INGESTED",
  PROCESSED: "PROCESSED",
  ERROR: "ERROR",
  FAILED: "FAILED",
  BUSINESS_PARTNER_VERIFIED: "BUSINESS_PARTNER_VERIFIED",
  BUSINESS_PARTNER_INGESTED: "BUSINESS_PARTNER_INGESTED",
} as const
export type IngestionStatus = (typeof IngestionStatus)[keyof typeof IngestionStatus]

export const IngestionStep = {
  VERIFY_BLANK_PRODUCTS: "VERIFY_BLANK_PRODUCTS",
  INGEST_BLANK_PRODUCTS: "INGEST_BLANK_PRODUCTS",
  VERIFY_PRODUCTS: "VERIFY_PRODUCTS",
  INGEST_PRODUCTS: "INGEST_PRODUCTS",
  LAUNCH_TRACEABILITY: "LAUNCH_TRACEABILITY",
} as const
export type IngestionStep = (typeof IngestionStep)[keyof typeof IngestionStep]

export const IngestionType = {
  PRODUCT: "PRODUCT",
  BUSINESS_PARTNER: "BUSINESS_PARTNER",
} as const
export type IngestionType = (typeof IngestionType)[keyof typeof IngestionType]

export const IngestionMethod = {
  MANUAL_ENTRY: "MANUAL_ENTRY",
  CSV_IMPORT: "CSV_IMPORT",
  API: "API",
  EXCEL_IMPORT: "EXCEL_IMPORT",
  THIRD_PARTY_INTEGRATION: "THIRD_PARTY_INTEGRATION",
} as const
export type IngestionMethod = (typeof IngestionMethod)[keyof typeof IngestionMethod]

export const FAQCategory = {
  DASHBOARD: "DASHBOARD",
  PRODUCTS: "PRODUCTS",
  SUPPLIERS: "SUPPLIERS",
  CERTIFICATES: "CERTIFICATES",
  DATA_TRANSFER: "DATA_TRANSFER",
  OTHER: "OTHER",
} as const
export type FAQCategory = (typeof FAQCategory)[keyof typeof FAQCategory]

export const NotificationType = {
  TRACEABILITY_DELIVERABILITY: "TRACEABILITY_DELIVERABILITY",
  TRACEABILITY_UNANSWERED: "TRACEABILITY_UNANSWERED",
} as const
export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType]

export const MappingTypes = {
  PRODUCT: "PRODUCT",
  MATERIAL: "MATERIAL",
  STANDARD: "STANDARD",
} as const
export type MappingTypes = (typeof MappingTypes)[keyof typeof MappingTypes]

export const SubscriptionPlan = {
  NONE: "NONE",
  STARTER: "STARTER",
  ADVANCED: "ADVANCED",
  EXPERT: "EXPERT",
} as const
export type SubscriptionPlan = (typeof SubscriptionPlan)[keyof typeof SubscriptionPlan]

export const AgecProductPagePlan = {
  STARTER: "STARTER",
  ESSENTIAL: "ESSENTIAL",
  ADVANCED: "ADVANCED",
} as const
export type AgecProductPagePlan = (typeof AgecProductPagePlan)[keyof typeof AgecProductPagePlan]

export const OutputCustomizationPlan = {
  ESSENTIAL: "ESSENTIAL",
  ADVANCED: "ADVANCED",
  EXPERT: "EXPERT",
} as const
export type OutputCustomizationPlan = (typeof OutputCustomizationPlan)[keyof typeof OutputCustomizationPlan]

export const LCACustomizationPlan = {
  ADVANCED: "ADVANCED",
  EXPERT: "EXPERT",
} as const
export type LCACustomizationPlan = (typeof LCACustomizationPlan)[keyof typeof LCACustomizationPlan]

export const CustomFieldsPlan = {
  ADVANCED: "ADVANCED",
  EXPERT: "EXPERT",
} as const
export type CustomFieldsPlan = (typeof CustomFieldsPlan)[keyof typeof CustomFieldsPlan]

export const CertificatesPlan = {
  ADVANCED: "ADVANCED",
  EXPERT: "EXPERT",
} as const
export type CertificatesPlan = (typeof CertificatesPlan)[keyof typeof CertificatesPlan]

export const OperationChainType = {
  PRODUCT: "PRODUCT",
  COMPONENT: "COMPONENT",
  MATERIAL: "MATERIAL",
} as const
export type OperationChainType = (typeof OperationChainType)[keyof typeof OperationChainType]

export const ZalandoPlan = {
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
} as const
export type ZalandoPlan = (typeof ZalandoPlan)[keyof typeof ZalandoPlan]

export const RduePlan = {
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
} as const
export type RduePlan = (typeof RduePlan)[keyof typeof RduePlan]

export const COMPONENT_TYPES = {
  TEXT_PARAGRAPH: "TEXT_PARAGRAPH",
  ACTIVITY_LIST: "ACTIVITY_LIST",
  RECYCLED_MATERIALS_INFO: "RECYCLED_MATERIALS_INFO",
  PACKAGING_INFO: "PACKAGING_INFO",
  TRIMAN_FOOTER: "TRIMAN_FOOTER",
  ECOSCORE: "ECOSCORE",
  POWERED_BY: "POWERED_BY",
  BULLETED_LIST: "BULLETED_LIST",
  TEXT_PARAGRAPH_V2: "TEXT_PARAGRAPH_V2",
  LOGO: "LOGO",
  GENERIC_PASSPORT_TITLE: "GENERIC_PASSPORT_TITLE",
  DETAILED_PRODUCT_COMPOSITION: "DETAILED_PRODUCT_COMPOSITION",
  PRODUCT_ATTRIBUTES: "PRODUCT_ATTRIBUTES",
  ORGANIZATION_TITLE: "ORGANIZATION_TITLE",
  PRODUCT_IMAGE: "PRODUCT_IMAGE",
} as const
export type COMPONENT_TYPES = (typeof COMPONENT_TYPES)[keyof typeof COMPONENT_TYPES]

export const TraceabilityMethods = {
  DEFAULT: "DEFAULT",
  PO: "PO",
  MULTISOURCING: "MULTISOURCING",
} as const
export type TraceabilityMethods = (typeof TraceabilityMethods)[keyof typeof TraceabilityMethods]

export const TraceabilitySourceContextType = {
  OPERATION: "OPERATION",
} as const
export type TraceabilitySourceContextType = (typeof TraceabilitySourceContextType)[keyof typeof TraceabilitySourceContextType]

export const TraceabilitySourceContextKind = {
  MULTI_SOURCE: "MULTI_SOURCE",
} as const
export type TraceabilitySourceContextKind = (typeof TraceabilitySourceContextKind)[keyof typeof TraceabilitySourceContextKind]

export const TraceabilitySourceContextStatus = {
  DRAFT: "DRAFT",
  REQUEST_LAUNCHED: "REQUEST_LAUNCHED",
  ANSWERED: "ANSWERED",
  ARCHIVED: "ARCHIVED",
  CANCELLED: "CANCELLED",
} as const
export type TraceabilitySourceContextStatus = (typeof TraceabilitySourceContextStatus)[keyof typeof TraceabilitySourceContextStatus]

export const RiskScore = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
} as const
export type RiskScore = (typeof RiskScore)[keyof typeof RiskScore]

export const JobStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const
export type JobStatus = (typeof JobStatus)[keyof typeof JobStatus]

export const ExportRequestStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  FAILED: "FAILED",
} as const
export type ExportRequestStatus = (typeof ExportRequestStatus)[keyof typeof ExportRequestStatus]

export const FileFormat = {
  CSV: "CSV",
  XLSX: "XLSX",
} as const
export type FileFormat = (typeof FileFormat)[keyof typeof FileFormat]

export const StorageType = {
  TFG_SFTP: "TFG_SFTP",
  CLIENT_SFTP: "CLIENT_SFTP",
} as const
export type StorageType = (typeof StorageType)[keyof typeof StorageType]

export const AlertType = {
  COUNT: "COUNT",
  AVG: "AVG",
  SUM: "SUM",
} as const
export type AlertType = (typeof AlertType)[keyof typeof AlertType]

export const FilterType = {
  STANDARD: "STANDARD",
  CUSTOM: "CUSTOM",
} as const
export type FilterType = (typeof FilterType)[keyof typeof FilterType]

export const FilterQueryType = {
  RAW: "RAW",
  JSON: "JSON",
} as const
export type FilterQueryType = (typeof FilterQueryType)[keyof typeof FilterQueryType]

export const ExportConfigurationSeparator = {
  COMMA: "COMMA",
  SEMICOLON: "SEMICOLON",
  TAB: "TAB",
  SPACE: "SPACE",
} as const
export type ExportConfigurationSeparator = (typeof ExportConfigurationSeparator)[keyof typeof ExportConfigurationSeparator]

export const ProductComponentType = {
  RAW_MATERIAL: "RAW_MATERIAL",
  COMPONENT: "COMPONENT",
  META_COMPONENT: "META_COMPONENT",
} as const
export type ProductComponentType = (typeof ProductComponentType)[keyof typeof ProductComponentType]

export const FacilityType = {
  MANUFACTURING: "MANUFACTURING",
  PROCESSING: "PROCESSING",
  WAREHOUSE: "WAREHOUSE",
  DISTRIBUTION_CENTER: "DISTRIBUTION_CENTER",
} as const
export type FacilityType = (typeof FacilityType)[keyof typeof FacilityType]

export const TransformationType = {
  CUTTING: "CUTTING",
  SEWING: "SEWING",
  DYEING: "DYEING",
  SPINNING: "SPINNING",
  WEAVING: "WEAVING",
  PRINTING: "PRINTING",
  FINISHING: "FINISHING",
  PACKAGING: "PACKAGING",
} as const
export type TransformationType = (typeof TransformationType)[keyof typeof TransformationType]

export const TemplateType = {
  REGULATORY: "REGULATORY",
  LIFECYCLE_ANALYSIS: "LIFECYCLE_ANALYSIS",
  SOCIAL_COMPLIANCE: "SOCIAL_COMPLIANCE",
  ENVIRONMENTAL_COMPLIANCE: "ENVIRONMENTAL_COMPLIANCE",
  CUSTOM: "CUSTOM",
} as const
export type TemplateType = (typeof TemplateType)[keyof typeof TemplateType]

export const TemplateStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  DEPRECATED: "DEPRECATED",
} as const
export type TemplateStatus = (typeof TemplateStatus)[keyof typeof TemplateStatus]

export const DatapointType = {
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  DATE: "DATE",
  DOCUMENT: "DOCUMENT",
  ENUM: "ENUM",
  BOOLEAN: "BOOLEAN",
  LOCATION: "LOCATION",
} as const
export type DatapointType = (typeof DatapointType)[keyof typeof DatapointType]

export const ResponseContextType = {
  FACILITY: "FACILITY",
  FACILITY_TRANSFORMATION: "FACILITY_TRANSFORMATION",
  TRANSFORMATION_INSTANCE: "TRANSFORMATION_INSTANCE",
  DOCUMENT: "DOCUMENT",
} as const
export type ResponseContextType = (typeof ResponseContextType)[keyof typeof ResponseContextType]

export const DatapointResponseVersionScope = {
  Operation: "Operation",
  CustomFieldValue: "CustomFieldValue",
} as const
export type DatapointResponseVersionScope = (typeof DatapointResponseVersionScope)[keyof typeof DatapointResponseVersionScope]

export const ResponseStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
} as const
export type ResponseStatus = (typeof ResponseStatus)[keyof typeof ResponseStatus]

export const BatchType = {
  PURCHASE_ORDER: "PURCHASE_ORDER",
  PRODUCTION_LOT: "PRODUCTION_LOT",
  SHIPPING_CONTAINER: "SHIPPING_CONTAINER",
  CUSTOM: "CUSTOM",
} as const
export type BatchType = (typeof BatchType)[keyof typeof BatchType]

export const CampaignStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
} as const
export type CampaignStatus = (typeof CampaignStatus)[keyof typeof CampaignStatus]

export const RequestStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
} as const
export type RequestStatus = (typeof RequestStatus)[keyof typeof RequestStatus]

export const RegistrationIdType = {
  VAT: "VAT",
  EORI: "EORI",
  GLN: "GLN",
  DUNS: "DUNS",
  RCS: "RCS",
  OTHER: "OTHER",
} as const
export type RegistrationIdType = (typeof RegistrationIdType)[keyof typeof RegistrationIdType]

export const OrganizationType = {
  PLATFORM_ADMIN: "PLATFORM_ADMIN",
  BRAND: "BRAND",
  MANUFACTURER: "MANUFACTURER",
  SUPPLIER: "SUPPLIER",
  CERTIFIER: "CERTIFIER",
  AUDITOR: "AUDITOR",
} as const
export type OrganizationType = (typeof OrganizationType)[keyof typeof OrganizationType]

export const BusinessRelationshipType = {
  AGENT: "AGENT",
  BRAND: "BRAND",
  MANUFACTURER: "MANUFACTURER",
  OTHER: "OTHER",
  RAW_MATERIAL_SUPPLIER: "RAW_MATERIAL_SUPPLIER",
  SUPPLIER: "SUPPLIER",
  TRADER: "TRADER",
} as const
export type BusinessRelationshipType = (typeof BusinessRelationshipType)[keyof typeof BusinessRelationshipType]

export const DocumentType = {
  SCOPE_CERTIFICATE: "SCOPE_CERTIFICATE",
  TRANSACTION_CERTIFICATE: "TRANSACTION_CERTIFICATE",
  SOCIAL_AUDIT: "SOCIAL_AUDIT",
  ENVIRONMENTAL_AUDIT: "ENVIRONMENTAL_AUDIT",
  TEST_REPORT: "TEST_REPORT",
  PROOF_OF_ORIGIN: "PROOF_OF_ORIGIN",
  CUSTOM_EXPORT: "CUSTOM_EXPORT",
  INVOICE: "INVOICE",
  OTHER: "OTHER",
} as const
export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType]

export const DocumentStatus = {
  VALID: "VALID",
  EXPIRED: "EXPIRED",
  REVOKED: "REVOKED",
  PENDING_VERIFICATION: "PENDING_VERIFICATION",
} as const
export type DocumentStatus = (typeof DocumentStatus)[keyof typeof DocumentStatus]

export const TraceabilityJobStatus = {
  RUNNING: "RUNNING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
} as const
export type TraceabilityJobStatus = (typeof TraceabilityJobStatus)[keyof typeof TraceabilityJobStatus]

export const ProductTraceabilityStatus = {
  PENDING: "PENDING",
  RUNNING: "RUNNING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
} as const
export type ProductTraceabilityStatus = (typeof ProductTraceabilityStatus)[keyof typeof ProductTraceabilityStatus]

export const DisplaySettingsSettingsScope = {
  LANGUAGES: "LANGUAGES",
  DESIGN_CUSTOMISATION: "DESIGN_CUSTOMISATION",
  COMPONENT_CUSTOMISATION: "COMPONENT_CUSTOMISATION",
  CONTENT_FILTERING: "CONTENT_FILTERING",
  PRODUCT_PAGE_COMPONENTS: "PRODUCT_PAGE_COMPONENTS",
} as const
export type DisplaySettingsSettingsScope = (typeof DisplaySettingsSettingsScope)[keyof typeof DisplaySettingsSettingsScope]

export const DisplaySettingsCustomisationCategories = {
  NONE: "NONE",
  GLOBAL: "GLOBAL",
  MAIN_HEADER: "MAIN_HEADER",
  ACTIVITIES: "ACTIVITIES",
  PACKAGING_INFO: "PACKAGING_INFO",
  SEARCH_ENGINE: "SEARCH_ENGINE",
  FOOTER: "FOOTER",
  ECOSCORE: "ECOSCORE",
  LOGO: "LOGO",
  GENERIC_PASSPORT_TITLE: "GENERIC_PASSPORT_TITLE",
  DETAILED_PRODUCT_COMPOSITION: "DETAILED_PRODUCT_COMPOSITION",
  PRODUCT_ATTRIBUTES: "PRODUCT_ATTRIBUTES",
  ORGANIZATION_TITLE: "ORGANIZATION_TITLE",
  PRODUCT_IMAGE: "PRODUCT_IMAGE",
} as const
export type DisplaySettingsCustomisationCategories = (typeof DisplaySettingsCustomisationCategories)[keyof typeof DisplaySettingsCustomisationCategories]

export const StylingParameterType = {
  VALUE: "VALUE",
  CSS_VARIABLE: "CSS_VARIABLE",
  CLASS: "CLASS",
} as const
export type StylingParameterType = (typeof StylingParameterType)[keyof typeof StylingParameterType]

export const FieldValueRequirement = {
  OPTIONAL: "OPTIONAL",
  REQUIRED: "REQUIRED",
} as const
export type FieldValueRequirement = (typeof FieldValueRequirement)[keyof typeof FieldValueRequirement]

export const DocumentRequirement = {
  NONE: "NONE",
  OPTIONAL: "OPTIONAL",
  REQUIRED: "REQUIRED",
} as const
export type DocumentRequirement = (typeof DocumentRequirement)[keyof typeof DocumentRequirement]

export const FieldConstraint = {
  STRING: "STRING",
  NUMBER: "NUMBER",
  SELECT: "SELECT",
  STANDARD: "STANDARD",
  MULTI_SELECT: "MULTI_SELECT",
} as const
export type FieldConstraint = (typeof FieldConstraint)[keyof typeof FieldConstraint]

export const UserOnboardingStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  BLOCKED: "BLOCKED",
} as const
export type UserOnboardingStatus = (typeof UserOnboardingStatus)[keyof typeof UserOnboardingStatus]

export const EcoModulationDatapointCode = {
  BONUS_DURABILITY: "BONUS_DURABILITY",
  BONUS_ENVIRONMENTAL_LABELS: "BONUS_ENVIRONMENTAL_LABELS",
  BONUS_RECYCLED_MATERIALS: "BONUS_RECYCLED_MATERIALS",
  MALUS_METALLOPLASTIC_FIBERS: "MALUS_METALLOPLASTIC_FIBERS",
  MALUS_EEE_COMPONENTS: "MALUS_EEE_COMPONENTS",
} as const
export type EcoModulationDatapointCode = (typeof EcoModulationDatapointCode)[keyof typeof EcoModulationDatapointCode]

